import { LinkButton } from 'components/controls/LinkButton';
import { IVirtualTableColumn } from 'components/layout/VirtualTable/Table/components/VirtualTable';
import { Opportunity } from '../../../queries/opportunity-list.queries.types';
import { DateTime } from 'luxon';
import CellContainer from 'components/Shared/CellContainer';

export const getOpportunityListTableColumns = (
   handleColumnClick: (ev: React.MouseEvent<HTMLElement>, column: IVirtualTableColumn<Opportunity>) => void,
   handleRowClick: (item: Opportunity) => void
): IVirtualTableColumn<Opportunity>[] => {

   const formatDate = (date?: Date): string => {
      if (!date) return '';

      const dt = DateTime.fromJSDate(date);
      return dt.toLocaleString({...DateTime.DATE_SHORT, weekday: 'short', month: 'short'});
   };

   return [
      {
         key: 'column1',
         name: 'Case ID',
         fieldName: 'observationId',
         minWidth: 40,
         maxWidth: 30,
         isResizable: false,
         isSorted: false,
         isSortedDescending: false,
         sortAscendingAriaLabel: 'Sorted A to Z',
         sortDescendingAriaLabel: 'Sorted Z to A',
         onColumnClick: handleColumnClick,
         data: 'string',
         isPadded: true,
         onRender: (item: Opportunity) => <CellContainer>{item.observationId}</CellContainer>
      },
      {
         key: 'column2',
         name: 'Incident Date',
         fieldName: 'incidentDate',
         minWidth: 110,
         maxWidth: 115,
         isResizable: false,
         isSorted: true,
         isSortedDescending: true,
         sortAscendingAriaLabel: 'Sorted A to Z',
         sortDescendingAriaLabel: 'Sorted Z to A',
         onColumnClick: handleColumnClick,
         data: 'string',
         isPadded: true,
         onRender: (item: Opportunity) => (
            <CellContainer>
               {formatDate(new Date(item.incidentDate))}
            </CellContainer>
         )
      },
      {
         key: 'column4',
         name: 'What Happened',
         fieldName: 'whatHappened',
         minWidth: 50,
         maxWidth: 200,
         isResizable: true,
         isSorted: false,
         isSortedDescending: false,
         sortAscendingAriaLabel: 'Sorted A to Z',
         sortDescendingAriaLabel: 'Sorted Z to A',
         onColumnClick: handleColumnClick,
         data: 'string',
         isPadded: true,
         onRender: (item: Opportunity) => <CellContainer>{item.whatHappened}</CellContainer>,
         sortValueResolver: (item: Opportunity) => item.whatHappened
      },
      {
         key: 'column5',
         name: 'Location',
         fieldName: 'locationType',
         minWidth: 60,
         maxWidth: 100,
         isResizable: false,
         isSorted: false,
         isSortedDescending: false,
         sortAscendingAriaLabel: 'Sorted A to Z',
         sortDescendingAriaLabel: 'Sorted Z to A',
         onColumnClick: handleColumnClick,
         data: 'string',
         isPadded: true,
         onRender: (item: Opportunity) => <CellContainer>{item.locationTypeDescription}</CellContainer>
      },
      {
         key: 'column6',
         name: 'Reach Name',
         fieldName: 'reachName',
         minWidth: 140,
         maxWidth: 190,
         isResizable: true,
         isSorted: false,
         isSortedDescending: false,
         sortAscendingAriaLabel: 'Sorted A to Z',
         sortDescendingAriaLabel: 'Sorted Z to A',
         onColumnClick: handleColumnClick,
         data: 'string',
         isPadded: true,
         onRender: (item: Opportunity) => <CellContainer>{item.reachName}</CellContainer>
      },
      {
         key: 'column7',
         name: 'Process Name',
         fieldName: 'processName',
         minWidth: 85,
         maxWidth: 100,
         isResizable: false,
         isSorted: false,
         isSortedDescending: false,
         sortAscendingAriaLabel: 'Sorted A to Z',
         sortDescendingAriaLabel: 'Sorted Z to A',
         onColumnClick: handleColumnClick,
         data: 'string',
         isPadded: true,
         onRender: (item: Opportunity) => <CellContainer>{item.processName}</CellContainer>
      },
      {
         key: 'column8',
         name: 'Depot',
         fieldName: 'depotPcName',
         minWidth: 80,
         maxWidth: 150,
         isResizable: true,
         isSorted: false,
         isSortedDescending: false,
         sortAscendingAriaLabel: 'Sorted A to Z',
         sortDescendingAriaLabel: 'Sorted Z to A',
         onColumnClick: handleColumnClick,
         data: 'string',
         isPadded: true,
         onRender: (item: Opportunity) => <CellContainer>{item.depotPcName}</CellContainer>
      },
      {
         key: 'column10',
         name: 'Status',
         fieldName: 'observationStatus',
         minWidth: 60,
         maxWidth: 70,
         isResizable: false,
         isSorted: false,
         isSortedDescending: false,
         sortAscendingAriaLabel: 'Sorted Open first',
         sortDescendingAriaLabel: 'Sorted Open last',
         onColumnClick: handleColumnClick,
         data: 'date',
         isPadded: true,
         onRender: (item: Opportunity) => (
            <CellContainer>{`${item.observationStatus.toProperCase()}`}</CellContainer>
         ),
         sortValueResolver: (item: Opportunity) => `${item.observationStatus.toProperCase()}`
      },
      {
         key: 'column11',
         name: '',
         minWidth: 20,
         maxWidth: 20,
         isResizable: false,
         data: 'date',
         isPadded: true,
         onRender: (item: Opportunity) => (
            <LinkButton
               text={'View'}
               onClick={e => {
                  e.preventDefault();
                  handleRowClick(item);
               }}
            />
         )
      }
   ];
};
